import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcDuplicate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2245_2987)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.20333 7.20313C7.20333 6.67682 7.20283 6.17205 7.20333 5.66728C7.20433 4.71832 7.83881 4.0513 8.78676 4.00273C8.83683 4.00022 8.88691 4.00022 8.93649 4.00022C12.0478 4.00022 15.1585 3.99972 18.2698 4.00022C19.0885 4.00022 19.6905 4.39783 19.9128 5.10391C19.9719 5.2907 19.9964 5.49601 19.9969 5.69231C20.0019 8.83463 20.0024 11.9769 19.9989 15.1193C19.9979 15.9991 19.4631 16.6551 18.6323 16.7783C18.3324 16.8229 18.0214 16.7943 17.7154 16.7968C17.417 16.7988 17.1185 16.7973 16.798 16.7973C16.798 17.1909 16.8025 17.5695 16.7965 17.9486C16.792 18.216 16.8035 18.4894 16.7545 18.7498C16.6268 19.4264 16.0253 19.9371 15.3363 19.9882C15.2492 19.9947 15.1615 19.9992 15.0744 19.9997C11.9571 20.0002 8.83984 20.0007 5.72206 19.9997C4.94637 19.9992 4.35647 19.6322 4.1156 18.9747C4.04249 18.7744 4.00593 18.549 4.00543 18.3352C3.99842 15.1803 3.99792 12.0255 4.00243 8.87068C4.00343 8.00185 4.53575 7.35236 5.36001 7.22316C5.64094 7.17909 5.93339 7.20563 6.22033 7.20363C6.53881 7.20113 6.8568 7.20313 7.20333 7.20313ZM18.3815 5.6197C15.1866 5.6197 12.0047 5.6197 8.82331 5.6197C8.82331 8.8156 8.82331 11.9975 8.82331 15.1808C12.0142 15.1808 15.1911 15.1808 18.3815 15.1808C18.3815 11.994 18.3815 8.8166 18.3815 5.6197ZM15.1841 16.7973C15.0879 16.7973 15.0138 16.7973 14.9392 16.7973C12.9466 16.7973 10.9541 16.7708 8.96253 16.8083C7.95498 16.8274 7.17078 16.0667 7.19181 15.0286C7.23137 13.0311 7.20333 11.0315 7.20333 9.03343C7.20333 8.96132 7.20333 8.88921 7.20333 8.8191C6.659 8.8191 6.14271 8.8191 5.61991 8.8191C5.61991 12.011 5.61991 15.1924 5.61991 18.3813C8.8148 18.3813 11.9962 18.3813 15.1841 18.3813C15.1841 17.8519 15.1841 17.3356 15.1841 16.7973Z",
				fill: "#828599"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2245_2987",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16.0015,
				height: 16,
				fill: "white",
				transform: "translate(4 4)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgIcDuplicate);
export default ForwardRef;
